import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../_metronic/layout";
import AdminsPage from "./modules/ContentManager/admins/AdminsPage";
import EditAdminsPage from "./modules/ContentManager/admins/EditAdminsPage";
import RankingGamesPage from "./modules/ContentManager/games/RankingGamesPage";
import QuizzesPage from "./modules/ContentManager/quizzes/QuizzesPage";
import ViewQuizPage from "./modules/ContentManager/quizzes/ViewQuizPage";
import ScenesPage from "./modules/ContentManager/scenes/ScenesPage";
import ViewScenePage from "./modules/ContentManager/scenes/ViewScenePage";
import EscapeRoomCreatePage from "./modules/ContentManager/escape-rooms/EscapeRoomCreatePage";
import EscapeRoomEditPage from "./modules/ContentManager/escape-rooms/EscapeRoomEditPage";
import ButtonCatalogSourcePage from "./modules/ContentManager/escape-rooms/ButtonCatalogSourcePage";
import TemplateCategoriesPage from "./modules/ContentManager/escape-rooms/TemplateCategoriesPage";
import { DashboardPage } from "./pages/DashboardPage";
import PlanLogsPage from "./modules/ContentManager/plan-logs/PlanLogsPage";
import PortalCustomersPage from "./modules/ContentManager/portal-users/PortalCustomersPage";
import PlansAdminPage from "./modules/ContentManager/plans/PlansAdminPage";
import SupportMessagesPage from "./modules/ContentManager/support-messages/SupportMessagesPage";
import BlogPostsPage from "./modules/ContentManager/blog-posts/BlogPostsPage";
import EditBlogPostPage from "./modules/ContentManager/blog-posts/EditBlogPostPage";
import PromoClientsPage from "./modules/ContentManager/promo-clients/PromoClientsPage";
import EditPromoClientPage from "./modules/ContentManager/promo-clients/EditPromoClientPage";
import PromoClientSectorsPage from "./modules/ContentManager/promo-clients/PromoClientSectorsPage";
import EditPromoClientSectorPage from "./modules/ContentManager/promo-clients/EditPromoClientSectorPage";
import PromoFaqsPage from "./modules/ContentManager/promo-faqs/PromoFaqsPage";
import EditPromoFaqPage from "./modules/ContentManager/promo-faqs/EditPromoFaqPage";
import ContactFormMessagesPage from "./modules/ContentManager/contact-form/ContactFormMessagesPage";
import BoxInvitesPage from "./modules/ContentManager/box-invites/BoxInvitesPage";
import PromoPortfolioProjectsPage from "./modules/ContentManager/promo-portfolio/PromoPortfolioProjectsPage";
import EditPromoPortfolioProjectPage from "./modules/ContentManager/promo-portfolio/EditPromoPortfolioProjectPage";
import PromoPortfolioSectorsPage from "./modules/ContentManager/promo-portfolio/PromoPortfolioSectorsPage";
import EditPromoPortfolioSectorPage from "./modules/ContentManager/promo-portfolio/EditPromoPortfolioSectorPage";

export default function BasePage() {
	return (
		<Switch>
			{/* Redirect from root URL to /dashboard. */}
			<Redirect exact from="/" to="/dashboard" />
			<ContentRoute path="/dashboard" component={DashboardPage} />
			<ContentRoute path="/plan-logs" component={PlanLogsPage} />
			<ContentRoute path="/portal-users" component={PortalCustomersPage} />
			<ContentRoute path="/plans-admin" component={PlansAdminPage} />
			<ContentRoute path="/support-messages" component={SupportMessagesPage} />
			{/* Administrators */}
			<ContentRoute from="/admins" component={AdminsPage} />
			<ContentRoute from="/edit-admin/:id?" component={EditAdminsPage} />
			{/* Blog */}
			<ContentRoute from="/blog-posts" component={BlogPostsPage} />
			<ContentRoute from="/edit-blog-post/:id?" component={EditBlogPostPage} />
			<ContentRoute from="/promo-clients" component={PromoClientsPage} />
			<ContentRoute from="/edit-promo-client/:id?" component={EditPromoClientPage} />
			<ContentRoute from="/promo-client-sectors" component={PromoClientSectorsPage} />
			<ContentRoute from="/edit-promo-client-sector/:id?" component={EditPromoClientSectorPage} />
			<ContentRoute from="/promo-faqs" component={PromoFaqsPage} />
			<ContentRoute from="/edit-promo-faq/:id?" component={EditPromoFaqPage} />
			<ContentRoute from="/contact-form-messages" component={ContactFormMessagesPage} />
			<ContentRoute from="/box-invites" component={BoxInvitesPage} />
			<ContentRoute from="/promo-portfolio-projects" component={PromoPortfolioProjectsPage} />
			<ContentRoute from="/edit-promo-portfolio-project/:id?" component={EditPromoPortfolioProjectPage} />
			<ContentRoute from="/promo-portfolio-sectors" component={PromoPortfolioSectorsPage} />
			<ContentRoute from="/edit-promo-portfolio-sector/:id?" component={EditPromoPortfolioSectorPage} />
			<ContentRoute
				from="/ranking-game/:id?"
				component={RankingGamesPage}
			/>
			{/* Escape Rooms */}
			<Redirect exact from="/escape-rooms" to="/escape-rooms/new" />
			<ContentRoute path="/escape-rooms/new" component={EscapeRoomCreatePage} />
			<ContentRoute path="/escape-rooms/button-catalog" component={ButtonCatalogSourcePage} />
			<ContentRoute path="/escape-rooms/template-types" component={TemplateCategoriesPage} />
			<ContentRoute path="/escape-rooms/:id" component={EscapeRoomEditPage} />
			{/* Scenes (legacy) */}
			<ContentRoute from="/scenarios" component={ScenesPage} />
			<ContentRoute from="/scenario/:id" component={ViewScenePage} />
			{/* Quizzes (legacy) */}
			<ContentRoute from="/quizzes" component={QuizzesPage} />
			<ContentRoute from="/quiz/:id" component={ViewQuizPage} />
			<Redirect to="/error" />
		</Switch>
	);
}
